// extracted by mini-css-extract-plugin
module.exports = {"blocks":"LoansLandingPage_blocks__MlKqd"};